// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const tracingInHoursMax = 168;

export const tracingInReasonMin = 3;
export const tracingInReasonMax = 500;

export const TracingIn = zod.object({
  "hours": zod.int().min(1).max(tracingInHoursMax),
  "reason": zod.string().min(tracingInReasonMin).max(tracingInReasonMax),
  "user_id": zod.union([zod.uuid(),zod.null()]).optional()
});

export type TracingIn = zod.input<typeof TracingIn>;
export type TracingInOutput = zod.output<typeof TracingIn>;
